export default "__VITE_ASSET__DCX9RMQi__"